import { EvmNFTCollectionContractName } from '@repo/types-client';

import { getEvmNFTCollectionByContractName } from './get-evm-nft-collection-by-contract-name';

/**
 * Retrieves the Ethereum address for a specific NFT collection contract
 * @param contract - The name of the NFT collection contract
 * @param normalize - Whether to convert the address to lowercase (default: true)
 * @returns The Ethereum address of the NFT collection contract
 */
export const getEvmNFTCollectionAddressByContractName = (
  contract: EvmNFTCollectionContractName,
  normalize = true,
): string => {
  const collection = getEvmNFTCollectionByContractName(contract);
  const address = collection.getAddress();
  return normalize ? address.toLowerCase() : address;
};

/**
 * Retrieves multiple Ethereum addresses for an array of NFT collection contracts
 * @param contracts - Array of NFT collection contract names
 * @param normalize - Whether to convert the addresses to lowercase (default: true)
 * @returns Array of Ethereum addresses corresponding to the input contract names
 */
export const getEvmNFTCollectionAddressesByContractNames = (
  contracts: EvmNFTCollectionContractName[],
  normalize = true,
): string[] => {
  return contracts.map((x) =>
    getEvmNFTCollectionAddressByContractName(x, normalize),
  );
};
